import React from "react";
import { Box } from "@mui/material";

const RefundInitiationFailedReceipt = ({ orderReport, formatpaymentTime, failedImg }) => {
  const refundInfo = orderReport?.data?.refundDetailInfoList?.[0];
  const items = orderReport?.data?.orderLineItem || [];
  

  if (refundInfo?.status !== "REFUND_INITIATION_FAILED") return null;

  return (
    <div style={{ marginTop: "5vw" }}>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
{/*         <Box
          component="img"
          src={failedImg}
          alt="Refund Initiation Failed"
          sx={{ maxHeight: 155, borderRadius: 2, width: "68px", height: "68px" }}
        /> */}
        <img src={failedImg} style={{width:"68px",height:"68px",borderRadius:"2px",maxHeight:155}}/>
      </Box>

      <h1 style={{
        color: "#C20C0C",
        fontSize: "20px",
        fontWeight: 600,
        textAlign: "center",
        marginTop: "2vw"
      }}>
        Refund Initiation Failed
      </h1>

      <div style={{marginTop:"8vw", padding: "0 5px 10px 5px" , border: "2px dotted #999", borderRadius: "6px",
   
    fontFamily: "Poppins",
    textAlign: "center", }}>
        <div
  style={{
   
   color: "#000000B2",
    fontSize: "14px",
    
  
  }}
>
    We encountered an issue while processing your refund.
</div>
      
      </div>

      <div className="rounded-lg p-3 mb-4">
        <p style={{ fontSize: "12px", fontWeight: "600", color: "#000" }}>
          <span style={{ color: "#898C8E" }}>Amount to be Refunded :</span> ₹ {refundInfo?.refundAmount}
        </p>
        <hr style={{ marginTop: "2.5vw", marginBottom: "2vw" }} />
        <p className="text-xs text-gray-600 mt-1">
          Expected Settlement Time: after initiation
        </p>
      </div>

      <div className="rounded-lg p-3 mb-4">
        <p style={{ fontSize: "12px", fontWeight: "600", color: "#000" }}>
          <span style={{ color: "#898C8E" }}>Order :</span> {items.length} Items
        </p>
        <hr style={{ marginTop: "2.5vw", marginBottom: "2vw" }} />
        <div className="grid grid-cols-3 text-center font-medium text-gray-600 text-xs pb-1">
          <div style={{ textAlign: "center" }}>Item(Count)</div>
          <div>Price/Unit</div>
          <div>Status</div>
        </div>

        {items.map((item, index) => (
          <div
            key={index}
            className="grid grid-cols-3 text-center text-sm mt-1 text-gray-800"
            style={{ fontSize: "10px" }}
          >
            <div style={{ textAlign: "center" }}>
              {item.variantName.length > 20
                ? item.variantName.slice(0, 20) + "..."
                : item.variantName}{" "}
              ({String(item.itemQuantity).padStart(2, "0")})
            </div>
            <div>₹ {item.amount}</div>
            <div className="text-red-500 font-medium">
              {item.successQuantity > 0 && (
                <span style={{ color: "#000000B2", fontSize: "10px", fontWeight: "700", fontFamily: "roboto" }}>
                  Success({item.successQuantity})
                </span>
              )}{" "}
              {item.failureQuantity > 0 && (
                <span style={{ color: "#E65C5C", fontSize: "10px", fontWeight: "700", fontFamily: "roboto" }}>
                  Failed({item.failureQuantity})
                </span>
              )}{" "}
              {item.vendRemaining > 0 && (
                <span style={{ color: "#F28618", fontSize: "10px", fontWeight: "700", fontFamily: "roboto" }}>
                  Pending({item.vendRemaining})
                </span>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="rounded-lg p-3">
        <p style={{ fontSize: "12px", fontWeight: "600", color: "#000" }}>
          <span style={{ color: "#898C8E" }}>Paid Amount :</span> ₹ {refundInfo?.paidAmount}
        </p>
        <hr style={{ marginTop: "2.5vw", marginBottom: "2vw" }} />
        <p style={{ fontSize: "10px", color: "#000000B2", fontWeight: 400 }}>
          {formatpaymentTime}
        </p>
        <p style={{ fontSize: "10px", color: "#000000B2", fontWeight: 400 }}>
          Transaction ID: {refundInfo?.transactionId}
        </p>
         <p style={{ fontSize: "10px", color: "#000000B2", fontWeight: 400 }}>
          Payment Method: {refundInfo?.pgName}
        </p>
      </div>

      {/* ✅ Final horizontal line added here */}
     <div style={{padding:".75rem"}}><hr style={{ marginTop: "2vw", borderTop: "1px solid #ddd" }} />
     </div> 
    </div>
  );
};

export default RefundInitiationFailedReceipt;
